import { getUpcomingDatesForDays, removePastDates } from "./HelperFunctions";

const getFirstAvailableBookingDate = (restrictionDates: any) => {
  if (!Array.isArray(restrictionDates) && restrictionDates?.length === 0) {
    return null;
  }
  let upcomingDates = getUpcomingDatesForDays(restrictionDates ?? []);
  upcomingDates = removePastDates(upcomingDates);
  if (upcomingDates?.length > 0) {
    return upcomingDates[0];
  } else {
    return null;
  }
};

export { getFirstAvailableBookingDate };
